export default "__VITE_ASSET__Bk_dI0mO__"